import { DELETE_FEIERTAGSKONTO_KONTOAUSGLEICH } from '@/domain/mitarbeiter/features/feiertagskonto/hooks/useDeleteKontoausgleich/graphql/mutation';
import {
  Exact,
  Mitarbeiter_DeleteFeiertagskontoKontoausgleichInput,
  Mitarbeiter_DeleteFeiertagskontoKontoausgleichMutation,
  Mitarbeiter_DeleteFeiertagskontoKontoausgleichMutationVariables,
} from '@/gql/graphql';
import { ApolloClient } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

type DelteKontoausgleichResult = {
  deleteKontoausgleich: (
    variables: Exact<{
      input: Mitarbeiter_DeleteFeiertagskontoKontoausgleichInput;
    }>,
  ) => Promise<
    ApolloClient.MutateResult<
      Mitarbeiter_DeleteFeiertagskontoKontoausgleichMutation,
      undefined
    >
  >;
  result: Mitarbeiter_DeleteFeiertagskontoKontoausgleichMutation;
};

export function useDeleteKontoausgleich(): DelteKontoausgleichResult {
  const [execute, { data }] = useMutation(
    DELETE_FEIERTAGSKONTO_KONTOAUSGLEICH,
    {
      refetchQueries: ['mitarbeiter_getFeiertagskonto'],
      awaitRefetchQueries: true,
    },
  );
  const deleteKontoausgleich = useCallback(
    (
      variables: Mitarbeiter_DeleteFeiertagskontoKontoausgleichMutationVariables,
    ) => {
      return execute({ variables });
    },
    [execute],
  );

  return { deleteKontoausgleich, result: data };
}
